import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import {AuthService} from '@/common/auth.service';

Vue.use(VueRouter);

const auth = AuthService;

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  mode: 'history',
  linkActiveClass: 'active',
  scrollBehavior: (to, from ,savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  }
});


router.beforeEach((to, from, next) => {
  const { authorize } = to.meta;
  const isAuthenticated = auth.isAuthenticated();
  if (authorize) {
      if (!isAuthenticated) {
          // not logged in so redirect to login page with the return url
          //auth.login();
          return next({ path: '/login', query: { returnUrl: to.path } });
      }

      if (auth.hasAccessTokenExpired()) {
        // not logged in so redirect to login page with the return url
        auth.logout();
        return next({ path: '/login', query: { returnUrl: to.path } });
      }

      // check if route is restricted by role
      const userRole = auth.getUserRole();
      if (authorize.length && !authorize.includes(userRole)) {
          // role not authorised so redirect to NotAuthorized page
          return next({ path: '/forbidden' });
      }
  }

  next();
})

export default router;
